
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import { scrollWatcher } from '~/helpers/scroll-watcher.js';
import {homePageWatcher} from "~/helpers/is-main-page";

export default BaseCmsBlock.extend({
  name: "BenefitsWorkingWithUsBlock",

  data: function () {
    return {
      isOpenFullMessage: false,
      isVisibleButtonMoreMessage: false,
      isAnimate: false,
      windowWidth: null,
    }
  },

  components: {
    BenefitCard: () => import("./components/BenefitsWorkingWithUsBlock/BenefitCard")
  },

  mounted: function () {
    this.handleWindowWidth();
    this.initMessage();
    window.addEventListener('resize', this.handleWindowWidth);
    document.addEventListener('scroll', this.inFieldOfView);
  },

  unmounted: function () {
    document.removeEventListener('scroll', this.inFieldOfView);
    window.removeEventListener('resize', this.handleWindowWidth);
  },

  computed: {
    isHome: function () {
      return homePageWatcher(this.$route.fullPath);
    },
    isMobile: function () {
      return this.windowWidth < 991;
    },
  },

  watch: {
    isMobile: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.initMessage();
      }
    }
  },
  methods: {
    initMessage: function () {
      if (!this.$refs.refRootMessage) {
        return;
      }

      // if (this.isMobile) {
      //   this.isVisibleButtonMoreMessage = true;
      //   this.isOpenFullMessage = false;
      //   return
      // }
      //
      // if (!this.isMobile) {
      //   this.isVisibleButtonMoreMessage = false;
      //   this.isOpenFullMessage = true;
      //   return
      // }

      const rootHeight = this.$refs.refRootMessage.clientHeight;
      const fullHeight = this.$refs.refFullMessage.clientHeight;

      if (fullHeight <= rootHeight || !this.isMobile) {
        this.isVisibleButtonMoreMessage = false;
        return;
      }

      this.isVisibleButtonMoreMessage = true;
      this.isOpenFullMessage = false;
    },
    openCloseFullMessage: function () {
      this.isOpenFullMessage = !this.isOpenFullMessage;
    },
    inFieldOfView: function () {
      if (scrollWatcher('benefits-working')) {
        document.removeEventListener('scroll', this.inFieldOfView);
        this.isAnimate = true;
      }
    },
    handleWindowWidth: function () {
      this.windowWidth = window.innerWidth;
    },
  },
})
